import { Observable } from "rxjs";

import { switchMap } from "rxjs/operators";

import { InitService } from "@core-services/init.service";
import { TradableWalletService } from "./tradable_wallet.service";
import { AssetTransaction } from "@models/transaction";
import { GetPendingTradesGQLService } from "@gql/offer";
import { DestructorService } from "@core-services/destructor.service";
import { Asset, AssetWallet } from "@models";

export abstract class AssetWalletService<
	AW extends AssetWallet,
	AT extends AssetTransaction,
	A extends Asset
> extends TradableWalletService<AW, AT, A> {
	protected constructor(
		protected initService: InitService,
		protected destructor: DestructorService,
		public name: string,
		protected getPendingTradesGQLService: GetPendingTradesGQLService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public confirmTransaction(walletId: string, transactionId: string, code: string): Observable<AT> {
		return this.apicallService
			.get(`wallet/${walletId}/transaction/${transactionId}/confirm/${code}`)
			.pipe(switchMap(() => this.getTransaction(walletId, transactionId)));
	}
}
